import { useQuery } from 'react-query';

import { useRequest, type QueryFunction } from '../common';
import { getAccountListQueryKey } from './keys';
import { AccountData } from './types';

export const useAccountList: QueryFunction<
  AccountData[],
  [],
  ReturnType<typeof getAccountListQueryKey>
> = ({ query, requestOptions, queryOptions } = {}) => {
  const request = useRequest(requestOptions);

  return useQuery({
    ...queryOptions,
    queryKey: getAccountListQueryKey(query),
    queryFn: ({ signal }) =>
      request('/accounts', {
        query,
        init: { signal },
      }),
  });
};
